/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   scroll to hash anchor
 */

import { ON_BROWSER } from '../env'

const goToHashIfInUrl = (hash) => {
  if (
    ON_BROWSER &&
    typeof window !== 'undefined' &&
    hash &&
    window?.location?.hash === `#${hash?.startsWith?.('#') ? hash.slice(1) : hash}`
  ) {
    setTimeout(() => {
      const element = document.getElementById(hash)
      if (element) {
        element.scrollIntoView()
      }
    }, 0)
  }
}

export default goToHashIfInUrl
